// ** Third Party Components
import Tooltip from "components/layout/Tooltip";

// ** Custom Components
import { ButtonSecondary } from "components/layout/Button/ButtonSecondary";
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";

// ** SVG Static Imports
import { ReactComponent as SolidPen } from "resources/icons/solid/pen.svg";
import { ReactComponent as SolidBan } from "resources/icons/solid/ban.svg";
import { ReactComponent as SolidComment } from "resources/icons/solid/comment-solid.svg";
import { ReactComponent as SolidUserPlus } from "resources/icons/solid/user-plus.svg";
import { ReactComponent as SolidUserMinus } from "resources/icons/solid/user-minus.svg";
import { ReactComponent as SolidTrash } from "resources/icons/solid/trash.svg";
import { ReactComponent as SolidLock } from "resources/icons/solid/lock.svg";
import { ReactComponent as SolidUnlock } from "resources/icons/solid/unlock.svg";
import { ReactComponent as SolidFolder } from "resources/icons/solid/folder.svg";

const svgIconsList = {
	["pen"]: SolidPen,
	["folder"]: SolidFolder,
	["ban"]: SolidBan,
	["comment"]: SolidComment,
	["user-plus"]: SolidUserPlus,
	["user-minus"]: SolidUserMinus,
	["trash"]: SolidTrash,
	["lock"]: SolidLock,
	["unlock"]: SolidUnlock,
};

// #####################################################

const TableActions = ({ actions, customInput, customInputWidth }) => {
	if (typeof actions === "object") {
		const { items, disabled } = actions;
		return items.map((item) => {
			const {
				key,
				dropdown,
				label,
				isBan,
				tooltipInfo,
				autoBorder,
				icon,
				...rest
			} = item;
			const buttonProps = {
				label,
				icon,
				...rest,
				disabled: item.disabled || disabled,
			};

			if (dropdown && dropdown.length > 0) {
				return (
					<SelectorSelectSingle
						key={key}
						label={label}
						items={dropdown}
						withMobileVersion
						noMaxWidth
						activatorStyleOptions={{ noFullWidth: true }}
						autoBorder={autoBorder}
						customActivator={({
							innerRef,
							toggle,
							layerSide,
							isOpenSelector,
						}) => (
							<Tooltip
								text={tooltipInfo || ""}
								wrapperStyle={{
									position: "relative",
									left: 0,
									right: 0,
									top: 0,
									bottom: 0,
								}}
							>
								<ButtonSecondary
									{...buttonProps}
									svgIconComponent={svgIconsList[icon]}
									dropdown
									layerSide={layerSide}
									isOpen={isOpenSelector}
									onClick={toggle}
									innerRef={innerRef}
									mr={2}
									mt={2}
									disabled={disabled || isBan}
									iconSize="0.85em"
									style={{
										minWidth: customInputWidth
											? customInputWidth
											: "unset",
									}}
								/>
							</Tooltip>
						)}
						useLayerOptions={{
							auto: true,
							possiblePlacements: ["top-start", "bottom-start"],
						}}
						customInputWidth={customInputWidth}
						customInput={customInput}
					/>
				);
			}
			return (
				<Tooltip
					key={key || item?.icon}
					text={tooltipInfo || ""}
					wrapperStyle={{
						position: "relative",
						left: 0,
						right: 0,
						top: 0,
						bottom: 0,
					}}
				>
					<ButtonSecondary
						key={key || item?.icon}
						svgIconComponent={svgIconsList[icon]}
						{...buttonProps}
						mr={2}
						mt={2}
						disabled={disabled || isBan}
						iconSize="0.85em"
					/>
				</Tooltip>
			);
		});
	}
	if (typeof actions === "function") {
		return actions();
	}
	return actions;
};

export default TableActions;

// #####################################################
